var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_3221",
    x: 0,
    y: 0,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83293",
    "data-name": "Group 83293",
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.5, -2)",
    filter: "url(#Path_3221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3221-2",
    "data-name": "Path 3221",
    d: "M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z",
    transform: "translate(3.5 2)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.113-17.493h-.836v9.609a1.23,1.23,0,0,1-.1.49,1.258,1.258,0,0,1-.268.4,1.257,1.257,0,0,1-.4.268,1.23,1.23,0,0,1-.49.1H3.339a1.23,1.23,0,0,1-.49-.1A1.257,1.257,0,0,1,2.451-7a1.258,1.258,0,0,1-.268-.4,1.23,1.23,0,0,1-.1-.49v-9.609H1.25v-.836H4.592v-.836a.81.81,0,0,1,.065-.326.849.849,0,0,1,.18-.264.849.849,0,0,1,.264-.18A.81.81,0,0,1,5.428-20H7.935a.81.81,0,0,1,.326.065.849.849,0,0,1,.264.18.849.849,0,0,1,.18.264.81.81,0,0,1,.065.326v.836h3.342Zm-6.685-.836H7.935v-.836H5.428Zm5.013.836H2.921v9.609a.4.4,0,0,0,.124.294.4.4,0,0,0,.294.124h6.685a.4.4,0,0,0,.294-.124.4.4,0,0,0,.124-.294ZM5.428-9.137H4.592v-6.685h.836Zm1.671,0H6.263v-6.685H7.1Zm1.671,0H7.935v-6.685H8.77Z",
    transform: "translate(6.94 27.168)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBgIcon);
export default __webpack_public_path__ + "static/media/delete_bg_icon.826ec4570522e0fce8e0271a700acf40.svg";
export { ForwardRef as ReactComponent };